// extracted by mini-css-extract-plugin
module.exports = {"slider":"onboarding-loading_slider__JEM2M","scroll":"onboarding-loading_scroll__DAMhb"};